module.exports = __webpack_public_path__ + "static/media/coborrowerinformationPrompt.98227529.svg";